import { Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GroupService } from "../../services/group-service";
import { useToast } from "../../context/toast-context";
import { useMemo } from "react";

interface DownloadExcelProps {
  branchId: number;
  branchName: string;
  disabled?: boolean;
}

export function DownloadExcel({ branchId, branchName, disabled = false }: DownloadExcelProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { showToast } = useToast();
  const groupService = useMemo(() => new GroupService(), []);

  const handleDownload = async () => {
    setIsLoading(true);
    
    try {
      await groupService.downloadGroupsExcel(
        branchId,
        (blob) => {
          // Crear URL para descargar el archivo
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `grupos-${branchName.replace(/\s+/g, '-').toLowerCase()}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          
          showToast(t("groups.excel.download.success"), "success");
        },
        (errorMessage) => {
          showToast(errorMessage, "error");
        }
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      disableElevation
      disabled={disabled || isLoading}
      onClick={handleDownload}
      sx={{
        background: "#2d2f32",
        margin: 0,
        padding: "0 10px",
        borderRadius: "999px",
        textTransform: "none",
        fontFamily: "Montserrat",
        fontWeight: 300,
        "&.Mui-disabled": {
          backgroundColor: "rgba(45, 47, 50, 0.5)",
          color: "rgba(255, 255, 255, 0.5)",
          "& svg": {
            opacity: 0.5,
          },
        },
      }}
      endIcon={
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#EF0BB8"
          strokeWidth="0"
        >
          <path
            d="M12 2C12.5523 2 13 2.44772 13 3V13.5858L16.2929 10.2929C16.6834 9.90237 17.3166 9.90237 17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929L11 13.5858V3C11 2.44772 11.4477 2 12 2ZM4 19C4 18.4477 4.44772 18 5 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z"
            fill="#EF0BB8"
            stroke="none"
          />
        </svg>
      }
    >
      {isLoading ? t("groups.excel.download.loading") : t("groups.excel.download.button")}
    </Button>
  );
}
